<template>
  <div>
    <h2> oi so um component</h2>
  </div>
</template>
<script type="text/javascript">
  import {get} from '../../helpers/api';
  import Loading from '../common/Loading';
  import {slugify} from '../../helpers/slugify';

  export default {
    name: "AlbumInterno",
    components: {
      Loading
    },
    data() {
      return {
        title: 'Álbuns',
        showContent: false,
        items: [],
        currentItem: [],
        showBanner: true
      }
    },
    mounted() {
      $('#imageGallery').lightSlider({
        gallery: true,
        item: 1,
        loop: true,
        thumbItem: 9,
        slideMargin: 0,
        enableDrag: false,
        currentPagerPosition: 'left',
        onSliderLoad: function (el) {
          el.lightGallery({
            selector: '#imageGallery .lslide'
          });
        }
      });
    },
    created() {
    },
    methods: {},
    watch: {}
  }
</script>


// WEBPACK FOOTER //
// src/components/interno/AlbumInterno.vue